import React, {useEffect, useState} from 'react';
import {
    Item,
} from "@shared/Resources/shared/components/OverviewListItem/styles";
import Loading from "@components/SectionLoading/index.js";
import {ListItem, SubList} from './styles'
import {
    SkillsItem
} from "@containers/Admin/containers/UserPage/user-page-wrapper/components/UserPersonalProgram/components/SkillsItem";
import {
    ListItemSection
} from "@containers/Admin/containers/UserPage/user-page-wrapper/components/UserPersonalProgram/components/ListItemSection";
import {RESOURCES} from "@shared/Resources/types";
import {useCustomSelector} from "src/hooks/useCustomSelector";
import { Skill } from '@app-types/skill.types';
import {StyledArrowDownIcon, StyledArrowRightIcon} from "./styles";

interface PersonalProgramListItemProps {
    item: Skill
    isExpandedAll: boolean
    isBeforeCurrentSkill?: boolean
}

export const SkillsListItem: React.FC<PersonalProgramListItemProps> = ({item, isExpandedAll, isBeforeCurrentSkill}) => {
    const [itemOpen, setItemOpen] = useState(false)
    const {overview: {resource}} = useCustomSelector('resourceManager')
    const onItemToggle = () => setItemOpen(prev => !prev)
    const highlightedByDefault = resource?.nextCourseActivity?.skillId === item.id

    useEffect(() => {
        setItemOpen(isExpandedAll)
    }, [isExpandedAll])

    useEffect(() => {
        highlightedByDefault && setItemOpen(highlightedByDefault)
    }, [])

    return (
        <ListItem>
            {itemOpen
                ? <StyledArrowDownIcon 
                    highlighted={highlightedByDefault} 
                    onClick={onItemToggle} 
                  />
                : <StyledArrowRightIcon 
                    highlighted={highlightedByDefault} 
                    onClick={onItemToggle} 
                  />
            }
            <Item>
                <SkillsItem
                    skill={item}
                    type={RESOURCES.SKILL}
                    isExpandable={true}
                    isFirstElement={true}
                    onExpand={onItemToggle}
                    isCurrentLevel={highlightedByDefault}
                />
            </Item>
            {(itemOpen) && <SubList>
                {resource ? <ListItemSection skill={item} isBeforeCurrentSkill={isBeforeCurrentSkill}/> : <Loading/>}
            </SubList>}
        </ListItem>
    );
};